export default __webpack_public_path__ + "static/media/dashboard.33d12a4a.svg";